import { CashFlowIncomeBankAccountItem } from "bus/cash/types/cashFlowIncomeBankAccount";

export const initValue: CashFlowIncomeBankAccountItem = {
  cashFlowItemId: null,
  comment: '',
  date: '',
  sum: 0
};